import InfiniteLoading from './InfiniteLoading';

export default InfiniteLoading;
